<article *ngIf="!isMobile" [ngSwitch]="currentModal">
    <section *ngSwitchCase="success">
        <app-moniepoint-success-modal *ngIf="!isMobile" #successModal (closeModal)="cancelModal()"
            [description]="modalBody" [title]="modalTitle" [useFullButton]="true" [btnText]="btnText">
        </app-moniepoint-success-modal>
    </section>
    <section *ngSwitchCase="failure">
        <app-moniepoint-failure-modal *ngIf="!isMobile" #failureModal (closeModal)="cancelModal()" (emitAction)="secondaryAction()" [secondaryButtonName]="secondaryButtonText" [useFailureSecondaryButton]="useFailureSecondaryButton"
            [description]="modalBody" [title]="modalTitle" [useFullButton]="true" [buttonText]="btnText">
        </app-moniepoint-failure-modal>
    </section>
    <section *ngSwitchCase="pending">
        <app-moniepoint-pending-modal *ngIf="!isMobile" #failureModal (closeModal)="cancelModal()"
            [description]="modalBody" [title]="modalTitle" [useFullButton]="true">
        </app-moniepoint-pending-modal>
    </section>
</article>
<nz-modal [(nzVisible)]="isMobile" [nzTitle]="null" [nzContent]="mobileView" [nzFooter]="null" [nzClosable]="false"
    [nzCentered]="true"
    [nzStyle]="{ padding: '0', margin: '0', maxWidth: '100%', width: '100vw', height: '100vh'}"
    [nzBodyStyle]="{ padding: '0', height: '100vh', width: '100vw'}" [nzMaskClosable]="false" [nzMask]="false">
    <ng-template #mobileView>
        <app-kamona-maximize-mobile-dialog *ngIf="isMobile" (emitAction)="cancelModal()" [buttonName]="'Dismiss'" (emitSecondaryAction)="secondaryAction()" [secondaryButtonName]="secondaryButtonText" [useFailureSecondaryButton]="useFailureSecondaryButton"
            [description]="modalBody" [mobileMessageType]="messageType" [title]="modalTitle">
        </app-kamona-maximize-mobile-dialog>
    </ng-template>
</nz-modal>
